import styled from 'styled-components';
import { Button } from '~/ui/buttons';
import PenEditIcon from '~/assets/icons/penEdit.svg';

export const EditBtnIcon = styled(PenEditIcon)``;

export const EditBtn = styled(Button)`
  background-color: #f3ecff;
  color: #9738ff;
  padding: 5px;

  position: absolute;
  top: 5px;
  right: 5px;
  margin: 0;

  &:hover {
    color: #fff;
    svg {
      path {
        fill: #fff !important;
      }
    }
  }
  &.active {
    background-color: #9845fb;
  }
`;
